import { Link, useLocation } from 'react-router-dom'

// styles
import styles from './styles.module.scss'

//components
import { FiPhoneCall } from 'react-icons/fi'
import { Statusbar } from '../../../components/Statusbar'
import { Button } from '../../../components/Button'
import { Header } from '@/components/Header'

export function StudentsFormStepSuccess() {
  const { pathname } = useLocation()
  const isEdit = pathname.includes('edit')
  const message = isEdit ? 'Edição concluída' : 'Cadastro concluído'
  return (
    <>
      <Header />
      <div className={styles.container}>
        <Statusbar step="step_4" />
        <div className={styles.content}>
          <h1>{message} com sucesso!</h1>
          <p>
            Aguarde que nossa equipe entrará em contato para efetivar sua
            matricula
          </p>
          <p>
            <FiPhoneCall></FiPhoneCall> (85)98210-6409
          </p>
          <p>
            <FiPhoneCall></FiPhoneCall> (85)21806407
          </p>
          <Link className={styles.back_button} to="/">
            <Button labelText="Voltar para a Home" />
          </Link>
        </div>
      </div>
    </>
  )
}
